import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import RichTextEditor from '../RichTextEditor';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Plus, Trash2 } from 'lucide-react';
import { formatDate } from './adminUtils';

export function NewsTab({ showNewsForm, setShowNewsForm, handleAddNews, newsForm, setNewsForm, newsSubmitting, news, handleDeleteNews }) {
  return (
    <>
      <div className="flex justify-end mb-4">
        <Dialog open={showNewsForm} onOpenChange={setShowNewsForm}>
          <DialogTrigger asChild>
            <Button className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="admin-add-news-btn">
              <Plus className="w-4 h-4 mr-2" /> Haber Ekle
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-lg">
            <DialogHeader><DialogTitle>Haber Ekle</DialogTitle></DialogHeader>
            <form onSubmit={handleAddNews} className="space-y-3 mt-2">
              <div>
                <Label>Başlık</Label>
                <Input value={newsForm.title} onChange={e => setNewsForm(p => ({...p, title: e.target.value}))} className="mt-1" required data-testid="admin-news-title" />
              </div>
              <div>
                <Label>İçerik</Label>
                <div className="mt-1" data-testid="admin-news-content">
                  <RichTextEditor
                    value={newsForm.content}
                    onChange={v => setNewsForm(p => ({...p, content: v}))}
                    placeholder="Haber içeriğini yazın..."
                    minHeight={220}
                  />
                </div>
              </div>
              <div>
                <Label>Görsel URL (isteğe bağlı)</Label>
                <Input value={newsForm.image_url} onChange={e => setNewsForm(p => ({...p, image_url: e.target.value}))} placeholder="https://..." className="mt-1" />
              </div>
              <Button type="submit" disabled={newsSubmitting} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="admin-news-submit">
                {newsSubmitting ? 'Ekleniyor...' : 'Haber Ekle'}
              </Button>
            </form>
          </DialogContent>
        </Dialog>
      </div>
      <div className="space-y-3">
        {news.map(n => (
          <div key={n._id} data-testid={`admin-news-${n._id}`} className="bg-white rounded-xl border border-slate-200 p-4 flex items-center gap-4">
            <div className="flex-1">
              <div className="font-semibold text-slate-800">{n.title}</div>
              <div className="text-xs text-slate-400 mt-0.5">{n.author_username} · {formatDate(n.created_at)}</div>
            </div>
            <button onClick={() => handleDeleteNews(n._id)} className="text-slate-300 hover:text-red-500 transition-colors" data-testid={`admin-delete-news-${n._id}`}>
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
        {news.length === 0 && <div className="text-center py-8 bg-white rounded-2xl border border-slate-100 text-slate-500">Haber bulunamadı</div>}
      </div>
    </>
  );
}
